module.exports = __webpack_public_path__ + "img/select_button.f0c299d9.png";